<template>
  <div>
    <v-radio-group
      v-model="delivery_method"
      label="Leveringsmåte"
      class="mt-0"
      @change="updateDeliveryMethod"
    >
      <v-radio
        v-for="deliveryMethod in deliveryMethods"
        :key="deliveryMethod.id"
        :label="
          deliveryMethod.name +
          ' (kr ' +
          parseFloat(deliveryMethod.price) +
          ',-)'
        "
        :value="deliveryMethod"
      />
    </v-radio-group>
  </div>
</template>

<script>
export default {
  name: "CheckoutDeliveryMethods",

  components: {},
  props: {
    order: {
      type: Object,
      required: true,
    },
    vendor: {
      type: Object,
      required: true,
    },
    deliveryMethods: {
      type: Array,
      required: true,
    },
  },

  data: () => ({
    delivery_method: null,
  }),

  methods: {
    updateDeliveryMethod() {
      this.$emit("update:deliveryMethod", this.delivery_method);
    },
  },
};
</script>

<style scoped>
.v-alert.payment-method-description {
  background-color: white !important;
}
</style>
